import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Card,
} from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import OrganizationService from "../../../Services/QRCodeServices/OrganizationManagement/OrganizationService";
import toast from "react-hot-toast";


const CreateOrgDbModal = ({ isOpen, toggleModal,selectedOrganization,selectedOrgName }) => {
  // Initial values for the form
  const [data,setData] = useState([])
  const [loading,setLoading] = useState(false)

  const initialValues = {
    orgId: selectedOrganization[0] || "",
    hostName: "",
    server: "",
    dbName: "",
    dbUser: "",
    dbPassword: "",
    adminEmail: "",
  };



const validationSchema = Yup.object({
  orgId: Yup.string()
    .required("Organization is required"),

  hostName: Yup.string()
    .required("Host Name is required"),

  server: Yup.string()
    .required("Server is required"),

  dbName: Yup.string()
    .required("Database Name is required"),

  dbUser: Yup.string()
    .required("Database User is required"),

  dbPassword: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters long")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(/[@$!%*?&#]/, "Password must contain at least one special character"),

  adminEmail: Yup.string()
    .email("Invalid email format")
    .required("Admin Email is required"),
});

  const handleSubmit = async (values) => {
    try {
      console.log(values);
      const res = await OrganizationService.createOrgDatabase({
        data: values,
      });
      console.log(res);
      toggleModal()
      toast.success("New Organization Database Addded! ");
    } catch (err) {
      toast.error("Error In Adding New Database! ");
      console.log(err);
    }
  };

 

  

  return (
    <Modal isOpen={isOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>
        Create Organization Database for <span className="fw-bold">{selectedOrgName}</span>
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, values }) => (
            <Form>
              <Row>
                
                <Col md={6} className="mb-2">
                  <Label for="adminEmail">Email: </Label>
                  <Input
                    name="adminEmail"
                    value={values.AdminEmail}
                    onChange={(e) =>
                      setFieldValue("adminEmail", e.target.value)
                    }
                    placeholder="Enter adminEmail"
                    className="form-control"
                    id="adminEmail"
                  />
                  <ErrorMessage
                    name="adminEmail"
                    component="div"
                    className="text-danger"
                  />
                </Col>
                <Col md={6} className="mb-2">
                  <Label for="dbPassword">Password: </Label>
                  <Input
                    name="dbPassword"
                    type="password"
                    value={values.DbPassword}
                    onChange={(e) =>
                      setFieldValue("dbPassword", e.target.value)
                    }
                    placeholder="Enter dbPassword"
                    className="form-control"
                    id="dbPassword"
                  />
                  <ErrorMessage
                    name="dbPassword"
                    component="div"
                    className="text-danger"
                  />
                </Col>

                <Col md={6} className="mb-2">
                  <Label for="hostName">Hostname: </Label>
                  <Input
                    name="hostName"
                    type="text"
                    value={values.HostName}
                    onChange={(e) => setFieldValue("hostName", e.target.value)}
                    placeholder="Enter hostName"
                    className="form-control"
                    id="hostName"
                  />
                  <ErrorMessage
                    name="hostName"
                    component="div"
                    className="text-danger"
                  />
                </Col>
                <Col md={6} className="mb-2">
                  <Label for="server">Server: </Label>
                  <Input
                    name="server"
                    type="text"
                    value={values.server}
                    onChange={(e) => setFieldValue("server", e.target.value)}
                    placeholder="Enter server"
                    className="form-control"
                    id="server"
                  />
                  <ErrorMessage
                    name="server"
                    component="div"
                    className="text-danger"
                  />
                </Col>
                <Col md={6} className="mb-2">
                  <Label for="dbName">Database Name: </Label>
                  <Input
                    name="dbName"
                    type="text"
                    value={values.dbName}
                    onChange={(e) => setFieldValue("dbName", e.target.value)}
                    placeholder="Enter dbName"
                    className="form-control"
                    id="dbName"
                  />
                  <ErrorMessage
                    name="dbName"
                    component="div"
                    className="text-danger"
                  />
                </Col>
                <Col md={6} className="mb-2">
                  <Label for="dbUser">Database User: </Label>
                  <Input
                    name="dbUser"
                    as="textarea"
                    value={values.dbUser}
                    onChange={(e) => setFieldValue("dbUser", e.target.value)}
                    placeholder="Enter dbUser"
                    className="form-control"
                    id="hostName"
                  />
                  <ErrorMessage
                    name="dbUser"
                    component="div"
                    className="text-danger"
                  />
                </Col>
              </Row>

              <ModalFooter>
                <Button color="secondary" onClick={toggleModal}>
                  Cancel
                </Button>
                <Button color="primary" type="submit" disabled={loading}>
                  Submit
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default CreateOrgDbModal;
